import { render, staticRenderFns } from "./ChatTalk.vue?vue&type=template&id=5cac7ce0&scoped=true&"
import script from "./ChatTalk.vue?vue&type=script&lang=js&"
export * from "./ChatTalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac7ce0",
  null
  
)

export default component.exports